import 'jquery-ui-bundle';
import 'spectrum-colorpicker';
import '@loadingio/loading-bar';
import 'jstree';
//var sassJs = require('sass.js');

$(function () {
    function getAttributes($node) {
        var attrs = {};
        $.each($node[0].attributes, function (index, attribute) {
            attrs[attribute.name] = attribute.value;
        });

        return attrs;
    }
    function editViewElement(ele) {
        var data = getAttributes(ele);
        console.log(data);
        $.each(data, function (k, v) {
            var editOpt = $('[name="' + k + '"]');
            console.log(editOpt.attr('type') + k);
            console.log(editOpt.get(0));
            if (editOpt.get(0)) {
                switch (editOpt.attr('type')) {
                    case 'text':
                    case 'select':
                        editOpt.val(v);
                        break;
                    case 'radio':
                        // code block
                        editOpt
                            .filter('[value="' + v + '"]')
                            .prop('checked', true);
                        break;
                    case 'icon':
                        editOpt.get(0).className = v;
                        break;
                    case 'tab':
                        // code block
                        // alert('tab')
                        if (v > 0) v = v - 1;
                        editOpt.tabs('option', 'active', v);
                        break;
                    default:
                        // code block
                        break;
                }
            }
        });
    }
    function editViewDesign(ele) {}
    function openFullscreen(elem) {
        if (elem.requestFullscreen) {
            elem.requestFullscreen();
        } else if (elem.mozRequestFullScreen) {
            /* Firefox */
            elem.mozRequestFullScreen();
        } else if (elem.webkitRequestFullscreen) {
            /* Chrome, Safari & Opera */
            elem.webkitRequestFullscreen();
        } else if (elem.msRequestFullscreen) {
            /* IE/Edge */
            elem.msRequestFullscreen();
        }
    }
    $(document).ready(function () {
        //document.write('<form action="/action_page.php">First name:<br><input type="text" name="firstname" value="Mickey"><br>Last name:<br><input type="text" name="lastname" value="Mouse"><br><br><input type="submit" value="Submit"></form> ')
        // var sass = new Sass();
        // var scss = '$someVar: 123px; .some-selector { width: $someVar; }';
        // sass.compile(scss, function(result) {
        //   console.log(result);
        // });
        var menu = $(parent.wex.page.nav.right);

        $('.preveiwFull').click(function () {
            openFullscreen($('.menufPreview').get(0));
        });

        $('.nemu-panel').draggable({
            snap: '.menuPreview',
            containment: '.menuPreview',
            start: function (event, ui) {
                var overlaypanel = $('<div class="overlaypanel"></div>').css({
                    opacity: '0.0',
                    position: 'absolute',
                    left: '0px',
                    top: '0px',
                    width: $(document).width(),
                    height: $('.menuPreview').height(),
                });
                $('.menuPreview').prepend(overlaypanel);
            },
            stop: function (event, ui) {
                $('.overlaypanel').remove();
            },
        });
        $('.container-presetDesign').load(
            wex.cdn.cdnMenuDesign,
            function (response, status, xhr) {
                $(this)
                    .find('icon')
                    .unbind('click')
                    .bind('click', function () {
                        var ofW = $('.menufPreview').get(0).contentWindow;
                        var menuID = $(this).attr('menu');
                        var menuCss = ofW.$('#menuCss');

                        menuCss.attr(
                            'href',
                            menuCss
                                .attr('href')
                                .replace(/[^\/]*?\.css/gim, menuID + '.css')
                        );
                    });
            }
        );

        $('.menufPreview')
            .attr('src', previewURL)
            .on('load', function (e) {
                var ofW = $('.menufPreview').get(0).contentWindow;
                var menuID = $(this).attr('menu');
                var menu = $(parent.wex.page.nav.right);
                var menuCss = ofW.$('#menuCss');
                var pathCss = wex.cdn.cdnURL + '/service/html/menu/css/';
                var menuCssHref = menuCss.attr('href');
                menuCssHref = menuCssHref.replace(
                    /\/storage\/myheader\/menu\//gim,
                    pathCss
                ); //.replace('full-window.css-main.css','full-window.css')
                menuCss.attr('href', menuCssHref);
                console.log('styleSheets');
                console.log(ofW.document.styleSheets);
                if (!ofW.$('#menuStyle').get(0)) {
                    ofW.$('head').append($('<style id="menuStyle"></style>'));
                }
                // build preset panel
                //  var con = ofW.$('<div class="container-presetDesign" style="backgound:#fff;position: fixed; right: 50px; min-height: 20px; width: 230px; top: 150px; border: 1px solid rgb(205, 205, 205); padding: 0px;""></div>')
            });

        //parent.wex.cdn.cdnMenuDesign

        $('.menuNav-set').html(
            menu
                .find('a')
                .each(function () {
                    var data = $(this).html();
                    $(this).replaceWith('<alink>' + data + '</alink>');
                })
                .end()
        );

        $('.addmenu')
            .each(function () {
                var cmd = $(this).attr('cmd');
                // alert($('section[name='+cmd+']').html())
                if (cmd) {
                    $(this).attr('data', $('section[name=' + cmd + ']').html());
                }
                console.log(
                    cmd + '----' + $('section[name=' + cmd + ']').html()
                );
            })
            .click(function () {
                var data = $(this).attr('data');
                var ofW = $('.menufPreview').get(0).contentWindow;
                data = $(data);
                // alert(data)
                ofW.$('#selected_navigator,.selected_navigator').html(data);
            });

        var optSort = {
            connectWith: 'ul',
            placeholder: 'arrow',
            change: function () {
                console.log('change');
            },
            receive: function () {
                console.log('receive');
            },
            activate: function () {
                console.log('activate');
            },
        };
        $('#menuSetting').tabs();
        $('#menuDesignSetting').tabs();
        $('#menuNav-tabs').tabs({
            create: function (event, ui) {
                $('.menuNav-set li')
                    .each(function () {
                        var newUL = $('<ul class="sub"></ul>');
                        $(this).append(newUL);
                    })
                    .mousedown(function (e) {
                        editViewElement($(this));
                        editViewDesign($(this));
                    });
                $('.menuNav-set>ul').sortable(optSort);
                $('.sub').sortable(optSort);
            },
            activate: function (event, ui) {
                //ui.newTab.index()
                console.log(ui.newTab.html());
                var index = ui.newTab.index();
                console.log(ui.newTab.find('a').get(0));
                var cmd = ui.newTab.find('a').attr('cmd');
                console.log(cmd);
                switch (cmd) {
                    case 'structure':
                        $('.container-preview').hide();
                        $('.container-ElementConfig').show();
                        break;
                    case 'design':
                        $('.container-ElementConfig').hide();
                        $('.container-preview').show();

                        break;
                    default:
                        // code block
                        break;
                }
            },
        });
        $('.tabs-prop,.NavLinkTos').tabs();

        var oPageList = {};
        oPageList['jstreepage'] = function () {
            return wex.page.page_tree;
        };
        oPageList['jstreeblog'] = function () {
            var dataBlog = JSON.parse(JSON.stringify(wex.blog.blog_lists));
            // var dataBlog = JSON.parse(JSON.stringify(wex.blog.blog_lists));
            $.each(dataBlog, function (k, v) {
                v['parent'] = '#';
            });

            return dataBlog;
        };

        oPageList['jstreesystem'] = function () {
            console.log('//////////////////////////');
            console.log(wex.systempage.non_editable_lists);
            var systempage = wex.systempage.editable_lists.concat(
                wex.systempage.non_editable_lists
            );

            var jsonListSystem = wex.systempage.nonedit_module_lists.concat(
                systempage
            );

            return jsonListSystem;
        };

        function listPage() {}
        //#jstree-page,#jstree-blog
        $('#jstreepage,#jstreeblog,#jstreesystem')
            .jstree({
                core: {
                    data: function (obj, cb) {
                        var id = $(this.element).get(0).id.replace('#', '');
                        console.log(id);
                        console.log(oPageList[id]);
                        cb.call(this, oPageList[id]());
                    },
                    check_callback: true,
                },
                types: {
                    default: {
                        icon: 'icon-visibility parent-normal',
                    },
                    home: {
                        icon: 'icon-visibility home-normal',
                        a_attr: { style: 'font-weight:bold' },
                    },
                    blogindex: {
                        icon: 'icon-visibility system-normal',
                        a_attr: {
                            style:
                                'opacity: 0.5; color: currentColor; cursor: not-allowed;text-decoration: none;',
                        },
                    },
                    hide: {
                        icon: 'icon-visibility parent-normal',
                        a_attr: { style: 'opacity: 0.5' },
                    },
                    internalpage: {
                        icon: 'icon-visibility internal-normal',
                    },
                    internalpagedraft: {
                        icon: 'icon-visibility internal-normal',
                        a_attr: { style: 'opacity: 0.5' },
                    },
                    member: {
                        icon: 'icon-visibility parent-member',
                    },
                    restricted: {
                        icon: 'icon-visibility parent-specific ',
                    },
                    post: {
                        icon: 'icon-visibility bpost-normal',
                        a_attr: {
                            style:
                                'opacity: 0.5; color: currentColor; cursor: not-allowed;text-decoration: none;',
                        },
                    },
                },
                search: {
                    case_insensitive: true,
                    show_only_matches: true,
                    search_leaves_only: false,
                    show_only_matches_children: false,
                },
                plugins: ['types', 'search'],
            })
            .on('ready.jstree', function (e) {})
            .on('loaded.jstree', function () {
                $(this).jstree('open_all');
            });

        $('.InputJstree').keyup(function () {
            $(this).next().jstree('search', $(this).val());
        });
    });
});
